/* tslint:disable */
/* eslint-disable */
/**
 * AdServer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { EarningsFromJSON, EarningsToJSON, } from '../models/index';
/**
    * Converts a number to a padded string
    * @param num The number to stringify
    * @param size Number of total digits
    */
function pad(num, size) {
    let negative = num < 0;
    if (negative) {
        num *= -1;
    }
    let numString = num.toString();
    while (numString.length < size)
        numString = "0" + numString;
    return (negative ? "-" : "") + numString;
}
/**
    * Returns a date in the RFC3339 format, e.g.: 2016-01-19T15:21:32.59+02:00
    * @param dateTime
    */
export function toRFC3339(dateTime) {
    let rfcWithoutTimeoffset = `${dateTime.getFullYear()}-${pad(dateTime.getMonth() + 1, 2)}-${pad(dateTime.getDate(), 2)}T${pad(dateTime.getHours(), 2)}:${pad(dateTime.getMinutes(), 2)}:${pad(dateTime.getSeconds(), 2)}${dateTime.getMilliseconds() != 0 ? "." + pad(dateTime.getMilliseconds(), 3) : ""}`;
    let timeOffsetString;
    let to = dateTime.getTimezoneOffset() * -1;
    let toh = Math.floor(to / 60);
    let tom = to % 60;
    if (tom < 0) {
        tom *= -1;
    }
    timeOffsetString = pad(toh, 2) + ":" + pad(tom, 2);
    return rfcWithoutTimeoffset + (toh > 0 ? "+" : "") + timeOffsetString;
}
/**
 *
 */
export class EarningsApi extends runtime.BaseAPI {
    /**
     * Retrieves aggregated earning statistics for this booking in the given timeframe and aggregation
     */
    async earningsBookingBookingIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters['bookingId'] == null) {
            throw new runtime.RequiredError('bookingId', 'Required parameter "bookingId" was null or undefined when calling earningsBookingBookingIdGet().');
        }
        const queryParameters = {};
        if (requestParameters['from'] != null) {
            queryParameters['from'] = toRFC3339(requestParameters['from']);
        }
        if (requestParameters['to'] != null) {
            queryParameters['to'] = toRFC3339(requestParameters['to']);
        }
        if (requestParameters['aggregation'] != null) {
            queryParameters['aggregation'] = requestParameters['aggregation'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/earnings/booking/{bookingId}`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters['bookingId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Retrieves aggregated earning statistics for this booking in the given timeframe and aggregation
     */
    async earningsBookingBookingIdGet(requestParameters, initOverrides) {
        const response = await this.earningsBookingBookingIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Retrieves totals for earning statistics for this booking
     */
    async earningsBookingBookingIdTotalGetRaw(requestParameters, initOverrides) {
        if (requestParameters['bookingId'] == null) {
            throw new runtime.RequiredError('bookingId', 'Required parameter "bookingId" was null or undefined when calling earningsBookingBookingIdTotalGet().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/earnings/booking/{bookingId}/total`.replace(`{${"bookingId"}}`, encodeURIComponent(String(requestParameters['bookingId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => EarningsFromJSON(jsonValue));
    }
    /**
     * Retrieves totals for earning statistics for this booking
     */
    async earningsBookingBookingIdTotalGet(requestParameters, initOverrides) {
        const response = await this.earningsBookingBookingIdTotalGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
